import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import {AuthService} from '@/services/auth-service';
import {logger, redact} from '@/utils/logger';

export default {
  data() {
    return {
      validateToken: null,
    };
  },
  components: {
    VueHcaptcha,
  },
  methods: {
    triggerCaptcha() {
      this.$refs.hcaptcha.execute();
    },
    async onHcaptchaVerify(token) {
      try {
        const {data} = await AuthService.validate(token);
        logger.info('Captcha validate success', {
          component: this.$options.name,
          validateToken: redact(data.token),
        });
        this.validateToken = data.token;
        this.postHcaptchaVerify();
      } catch (error) {
        logger.error('Captcha validate failed', {
          component: this.$options.name,
          status: error.response && error.response.status,
          isNetworkError: !error.response,
        }, error);
        this.error = 'Captcha validation failed';
        this.validateToken = null;
      }
    },
    onHcaptchaError(error) {
      logger.warn('hCaptcha widget error', {
        component: this.$options.name,
        error: String(error),
      });
      this.error = 'Captcha failed';
      this.validateToken = null;
    },
    postHcaptchaVerify() {

    },
  },
  siteKey: '6979ef7d-361a-4083-bb28-6d40bf4bf641',
}
